<div id="viewerContent"></div>


// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/report/report.component.html